/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminPaymentEnumItem } from './AdminPaymentEnumItem';
import {
    AdminPaymentEnumItemFromJSON,
    AdminPaymentEnumItemFromJSONTyped,
    AdminPaymentEnumItemToJSON,
    AdminPaymentEnumItemToJSONTyped,
} from './AdminPaymentEnumItem';
import type { AdminPaymentItem } from './AdminPaymentItem';
import {
    AdminPaymentItemFromJSON,
    AdminPaymentItemFromJSONTyped,
    AdminPaymentItemToJSON,
    AdminPaymentItemToJSONTyped,
} from './AdminPaymentItem';

/**
 * 
 * @export
 * @interface AdminPaymentListVo
 */
export interface AdminPaymentListVo {
    /**
     * 当前页
     * @type {number}
     * @memberof AdminPaymentListVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof AdminPaymentListVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof AdminPaymentListVo
     */
    totalRecord?: number;
    /**
     * 支付单记录列表
     * @type {Array<AdminPaymentItem>}
     * @memberof AdminPaymentListVo
     */
    records?: Array<AdminPaymentItem>;
    /**
     * 结算方式枚举列表
     * @type {Array<AdminPaymentEnumItem>}
     * @memberof AdminPaymentListVo
     */
    payTypeList?: Array<AdminPaymentEnumItem>;
}

/**
 * Check if a given object implements the AdminPaymentListVo interface.
 */
export function instanceOfAdminPaymentListVo(value: object): value is AdminPaymentListVo {
    return true;
}

export function AdminPaymentListVoFromJSON(json: any): AdminPaymentListVo {
    return AdminPaymentListVoFromJSONTyped(json, false);
}

export function AdminPaymentListVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminPaymentListVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(AdminPaymentItemFromJSON)),
        'payTypeList': json['payTypeList'] == null ? undefined : ((json['payTypeList'] as Array<any>).map(AdminPaymentEnumItemFromJSON)),
    };
}

export function AdminPaymentListVoToJSON(json: any): AdminPaymentListVo {
    return AdminPaymentListVoToJSONTyped(json, false);
}

export function AdminPaymentListVoToJSONTyped(value?: AdminPaymentListVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(AdminPaymentItemToJSON)),
        'payTypeList': value['payTypeList'] == null ? undefined : ((value['payTypeList'] as Array<any>).map(AdminPaymentEnumItemToJSON)),
    };
}

